import React from 'react';
import { Segment, Pagination } from 'semantic-ui-react';
import { VerifiedCallerIdDataTable } from './VerifiedCallerIdDataTable';
import { VerifiedCallerIdRow } from './VerifiedCallerIdRow';
import { VerifiedCallerIdFilter } from './VerifiedCallerIdFilter';
import { VerifiedCallerIdStats } from './VerifiedCallerIdStats';
import ConfirmationModal from '../shared/ConfirmationModal';
import AddVerifiedCallerIdModal from './AddVerifiedCallerIdModal';
import VerificationCodeModal from './VerificationCodeModal';
import VerifyOtpModal from './VerifyOtpModal';
import api from '../../../../../api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const tableHeader = [
  {
    title: '',
    width: '1',
    sort: '',
  },
  {
    title: 'Phone Number',
    width: '4',
    sort: '',
  },
  {
    title: 'Friendly Name',
    width: '4',
    sort: '',
  },
  {
    title: 'Verification Method',
    width: '2',
    sort: '',
  },
  {
    title: 'Verification Status',
    width: '2',
    sort: 'verification_status',
  },
  {
    title: 'Action',
    width: '3',
    sort: '',
  },
];

const queryParams = ['_limit', '_order', '_sort', 'q', '_page'];

export default class VerifiedCallerIdList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      callerIds: [],
      _sort: 'phone_number',
      _page: 1,
      _order: 'asc',
      _limit: 10,
      q: '',
      totalCount: 0,
      loading: false,
      showDeleteConfirm: false,
      callerIdToDelete: null,
      showAddModal: false,
      actionLoading: false,
      successMessage: null,
      verificationData: null,
      showVerificationCode: false,
      showVerifyOtp: false,
      otpLoading: false,
      otpError: null,
      resendingCallerId: null,
    };
  }

  componentDidMount() {
    this.loadData({});
  }

  static directionConverter(order) {
    if (order === 'asc') {
      return 'ascending';
    } else if (order === 'desc') {
      return 'descending';
    } else {
      return null;
    }
  }

  handleSort = (clickedColumn) => {
    const { _sort, _order } = this.state;

    let newOrder = _order === 'asc' ? 'desc' : 'asc';
    if (_sort !== clickedColumn) {
      newOrder = 'asc';
    }

    this.loadData({
      _sort: clickedColumn,
      _page: 1,
      _order: newOrder,
    });
  };

  onChangeLimit = (event, data) => {
    if (data.value !== this.state._limit) {
      this.loadData({ _limit: data.value, _page: 1 });
    }
  };

  onSubmitFilter = (filterType, value) => {
    const newFilters = { _page: 1 };

    if (filterType === 'q') {
      newFilters.q = value;
    }

    this.setState(newFilters, () => {
      this.loadData(newFilters);
    });
  };

  onChangePage = (event, data) => {
    const { activePage } = data;
    if (activePage !== this.state._page) {
      this.loadData({ _page: activePage });
    }
  };

  loadData = async (params) => {
    const newState = Object.assign({}, this.state, params, { loading: true });
    queryParams.forEach(function (element) {
      if (!(element in params)) {
        params[element] = newState[element];
      }
    });

    this.setState(newState, async () => {
      try {
        let callerIds = [];
        let totalCount = 0;

        if (this.props.onLoadVerifiedCallerIds) {
          const data = await this.props.onLoadVerifiedCallerIds(params);
          callerIds = data.callerIds || [];
          totalCount = data.totalCount || callerIds.length;
        }

        let normalizedCallerIds = callerIds.map(item => ({
          ...item,
          id: item.id || item.phone_number,
          phone_number: item.phone_number || item.twilio_phone,
        }));

        let filteredCallerIds = normalizedCallerIds;

        if (params.q && params.q.trim()) {
          filteredCallerIds = filteredCallerIds.filter((p) =>
            (p.phone_number || '').toLowerCase().includes(params.q.toLowerCase())
          );
        }

        if (params._sort) {
          filteredCallerIds.sort((a, b) => {
            const aVal = a[params._sort] || '';
            const bVal = b[params._sort] || '';
            if (params._order === 'asc') {
              return aVal > bVal ? 1 : -1;
            } else {
              return aVal < bVal ? 1 : -1;
            }
          });
        }

        this.setState({
          totalCount: filteredCallerIds.length,
          callerIds: filteredCallerIds,
          loading: false,
        });
      } catch (err) {
        console.error('Error loading verified caller IDs:', err);
        this.setState({ loading: false });
      }
    });
  };



  handleAddVerifiedCallerId = () => {
    this.setState({ showAddModal: true });
  };

  handleDeleteCallerId = (callerId) => {
    this.setState({
      callerIdToDelete: callerId,
      showDeleteConfirm: true,
    });
  };

  handleConfirmDelete = async () => {
    if (this.state.actionLoading) return;

    const callerId = this.state.callerIdToDelete;
    this.setState({ actionLoading: true });

    try {
      if (this.props.onDeleteVerifiedCallerId) {
        await this.props.onDeleteVerifiedCallerId(callerId);
      }
      this.setState({
        showDeleteConfirm: false,
        callerIdToDelete: null,
        actionLoading: false,
      });
      this.loadData({});
    } catch (err) {
      console.error('Delete error:', err);
      this.setState({ actionLoading: false });
    }
  };

  handleAddModalComplete = (responseData) => {
    this.setState({ showAddModal: false });

    if (responseData) {
      this.setState({
        verificationData: responseData,
        showVerificationCode: true,
      });
    }

    this.loadData({});
  };

  handleVerifyOtp = async (otp) => {
    const { verificationData } = this.state;
    if (!verificationData) return;

    this.setState({ otpLoading: true, otpError: null });

    try {
      const response = await api.trustHubCentralized.verifyVerifiedCallerIdOtp({
        record_id: verificationData.id,
        code: otp,
      });

      if (response?.success) {
        this.setState({
          showVerifyOtp: false,
          verificationData: null,
          otpLoading: false,
          successMessage: 'Phone number verified successfully!',
        });
        this.loadData({});
      } else {
        throw new Error(response?.message || 'OTP verification failed. Please try again.');
      }
    } catch (err) {
      this.setState({
        otpLoading: false,
        otpError: err.message || 'Failed to verify OTP. Please try again.',
      });
      throw err;
    }
  };

  handleCloseVerificationCode = () => {
    this.setState({
      showVerificationCode: false,
      verificationData: null,
      successMessage: 'Status will be updated shortly.',
    }, () => {
      this.loadData({});
    });
  };

  handleCloseVerifyOtp = () => {
    this.setState({
      showVerifyOtp: false,
      verificationData: null,
    });
  };

  handleResendOtp = async (callerId) => {
    this.setState({ resendingCallerId: callerId.id || callerId.phone_number });

    try {
      // Always use call — Twilio Outgoing Caller IDs only support voice validation.
      const response = await api.trustHubCentralized.addVerifiedCallerId({
        user_id: this.props.userId,
        country_code: callerId.country_code,
        phone_number: (callerId.phone_number || callerId.twilio_phone || '').replace(/[^0-9]/g, ''),
        extension: (callerId.extension || '').replace(/[^0-9]/g, ''),
        verification_method: 'call',
        friendly_name: callerId.friendly_name || '',
      });

      if (response?.success) {
        this.setState({
          verificationData: response.data || response,
          resendingCallerId: null,
          showVerificationCode: true,
        });
      } else {
        toast.error(response?.message || 'Failed to resend. Please try again.');
        this.setState({ resendingCallerId: null });
      }
    } catch (err) {
      console.error('Resend Error:', err);
      toast.error(err.message || 'Unable to resend. Please try again.');
      this.setState({ resendingCallerId: null });
    }
  };

  render() {
    const verifiedCount = this.state.callerIds.filter(
      (p) => (p.verification_status || p.status || '').toLowerCase() === 'verified' || (p.verification_status || p.status || '').toLowerCase() === 'approved'
    ).length;
    const pendingCount = this.state.callerIds.filter(
      (p) => (p.verification_status || p.status || '').toLowerCase() === 'pending' || (p.verification_status || p.status || '').toLowerCase() === 'verification-pending'
    ).length;
    const failedCount = this.state.callerIds.filter(
      (p) => (p.verification_status || p.status || '').toLowerCase() === 'failed' || (p.verification_status || p.status || '').toLowerCase() === 'verification-failed'
    ).length;

    const callerIdRows = this.state.callerIds.length > 0 ? this.state.callerIds.map((item, index) => (
      <VerifiedCallerIdRow
        key={item.id || item.phone_number || index}
        callerId={item}
        onDelete={this.handleDeleteCallerId}
        loading={this.state.actionLoading}
        onResendOtp={this.handleResendOtp}
        resending={this.state.resendingCallerId === (item.id || item.phone_number)}
      />
    )) : null;

    return (
      <div className="phone-inventory-list">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        {this.state.successMessage && (
          <div style={{
            padding: '12px 20px',
            marginBottom: '20px',
            backgroundColor: '#d4edda',
            color: '#155724',
            border: '1px solid #c3e6cb',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <i className="la la-check-circle" style={{ fontSize: '20px' }}></i>
              <span>{this.state.successMessage}</span>
            </div>
            <button
              onClick={() => this.setState({ successMessage: null })}
              style={{
                background: 'none',
                border: 'none',
                color: '#155724',
                cursor: 'pointer',
                fontSize: '18px',
                padding: '0 5px'
              }}
            >
              ×
            </button>
          </div>
        )}

        <div className="phone-inventory-header-row">
          <VerifiedCallerIdFilter
            filter={this.state.q}
            onSubmitFilter={this.onSubmitFilter}
            totalCount={this.state.totalCount}
            onAddVerifiedCallerId={this.handleAddVerifiedCallerId}
          />

          <VerifiedCallerIdStats
            totalCount={this.state.totalCount}
            verifiedCount={verifiedCount}
            pendingCount={pendingCount}
            failedCount={failedCount}
          />
        </div>

        {this.state.callerIds.length === 0 && !this.state.loading ? (
          <div className="empty-state-message">
            <div className="empty-icon">
              <i className="la la-phone"></i>
            </div>
            <h3>No Verified Caller IDs</h3>
            <p>Add a phone number to verify as a caller ID. Verified Caller IDs help improve call answer rates by displaying your business name or phone number when you make calls.</p>
            {/* <button
              className="btn linear-gradient zy-save-btn"
              onClick={this.handleAddVerifiedCallerId}
            >
              <i className="la la-plus"></i> Add Verified Caller ID
            </button> */}
          </div>
        ) : (
          <>
            <Segment style={{ width: '100%' }}>
              {this.state.loading && <div className="ui loading form"></div>}

              <VerifiedCallerIdDataTable
                callerIds={this.state.callerIds}
                tableHeader={tableHeader}
                callerIdRows={callerIdRows}
                column={this.state._sort}
                direction={VerifiedCallerIdList.directionConverter(this.state._order)}
                handleSort={this.handleSort}
                loading={this.state.loading}
              />
            </Segment>

            <div className="pagination-wrapper">
              <span>
                Showing 1 - {Math.min(this.state._limit, this.state.totalCount)} of{' '}
                {this.state.totalCount}
              </span>
              <Pagination
                totalPages={Math.ceil(this.state.totalCount / this.state._limit)}
                activePage={this.state._page}
                onPageChange={this.onChangePage}
              />
            </div>
          </>
        )}

        {/* Add Verified Caller ID Modal */}
        {this.state.showAddModal && (
          <AddVerifiedCallerIdModal
            userId={this.props.userId}
            onClose={() => this.setState({ showAddModal: false })}
            onComplete={this.handleAddModalComplete}
          />
        )}

        {/* Delete Confirmation Modal */}
        <ConfirmationModal
          isOpen={this.state.showDeleteConfirm}
          onClose={() =>
            this.setState({ showDeleteConfirm: false, callerIdToDelete: null })
          }
          onConfirm={this.handleConfirmDelete}
          title="Delete Verified Caller ID"
          message={`Are you sure you want to delete this verified caller ID?`}
          confirmText="Delete"
          cancelText="Cancel"
          loading={this.state.actionLoading}
        />

        {/* Verification Code Modal (Call method) */}
        {this.state.showVerificationCode && this.state.verificationData && (
          <VerificationCodeModal
            validationCode={this.state.verificationData.validation_code}
            phoneNumber={this.state.verificationData.phone_number || ''}
            verificationMethod="call"
            onClose={this.handleCloseVerificationCode}
          />
        )}

        {/* Verify OTP Modal (SMS method) */}
        {this.state.showVerifyOtp && this.state.verificationData && (
          <VerifyOtpModal
            phoneNumber={this.state.verificationData.phone_number || ''}
            onSubmit={this.handleVerifyOtp}
            onClose={this.handleCloseVerifyOtp}
          />
        )}
      </div>
    );
  }
}
